import React from 'react'
import Navbar from "../components/Navbar/Navbar"
import MarksComponent from '../components/marks/MarksComponent'

const MarksComponentPage = () => {
  return (
    <div>
       <Navbar/>
       <MarksComponent/>
    </div>
  )
}

export default MarksComponentPage